export * from '@fhs/routing/src/routes/rewards/offers';
export { default } from '@fhs/routing/src/routes/rewards/offers';
